import type { StrategyMode } from '../../types/strategy'

export interface StrategyConfig {
  mode: StrategyMode
  name: string
  tagline: string
  desc: string
  apyRange: string
  riskLabel: string
  riskLevel: 1 | 2 | 3
  accentClass: string
  borderClass: string
  bgClass: string
}

export const WIZARD_STRATEGIES: StrategyConfig[] = [
  {
    mode: 'CONSERVATIVE_CARRY',
    name: 'Conservative',
    tagline: 'Safe · Simple · Set it and forget it',
    desc: 'Stake your SOL to earn staking rewards, then lend it for extra yield. No borrowing, no liquidation risk.',
    apyRange: '5–8%',
    riskLabel: 'Low risk',
    riskLevel: 1,
    accentClass: 'text-emerald-400',
    borderClass: 'border-emerald-500/30',
    bgClass: 'bg-emerald-500/5',
  },
  {
    mode: 'BALANCED_CARRY',
    name: 'Balanced',
    tagline: 'More yield · Still manageable',
    desc: 'Stake → Lend → Borrow USDC → Add LP. Stack staking yield, lending yield, and trading fees.',
    apyRange: '10–15%',
    riskLabel: 'Medium risk',
    riskLevel: 2,
    accentClass: 'text-accent-blue',
    borderClass: 'border-accent-blue/30',
    bgClass: 'bg-accent-blue/5',
  },
  {
    mode: 'MAX_EARN_CARRY',
    name: 'Max Earn',
    tagline: 'Maximum yield · Higher risk',
    desc: 'Full Balanced strategy + automated hedging against price drops + leverage loops for peak yield.',
    apyRange: '20–35%',
    riskLabel: 'Higher risk',
    riskLevel: 3,
    accentClass: 'text-accent-purple',
    borderClass: 'border-accent-purple/30',
    bgClass: 'bg-accent-purple/5',
  },
]
